import { Dispatch } from "react"

import { Action, CheckoutActionKind, State } from "../types/checkoutTypes"

export const decrementCartItem = (
  cartItemId: string,
  state: State,
  dispatch: Dispatch<Action>,
  seatsProductId?: string
) => {
  const { cartItems } = state
  const existingItem = cartItems.find(item => item.productId === cartItemId)

  if (!existingItem || existingItem.quantity === 0) return

  if (seatsProductId) {
    const seatsItem = cartItems.find(item => item.productId === seatsProductId)
    if (seatsItem && seatsItem.quantity > 0) {
      //decrement the seats first
      dispatch({
        type: CheckoutActionKind.DECREMENT_CART_ITEM,
        payload: { cartItemId: seatsProductId },
      })
      return
    }
  }

  if (existingItem.quantity === 1) {
    return
  }

  dispatch({
    type: CheckoutActionKind.DECREMENT_CART_ITEM,
    payload: { cartItemId },
  })
}
